import { render, staticRenderFns } from "./NotificationCreate.vue?vue&type=template&id=218d17f8&scoped=true&"
import script from "./NotificationCreate.vue?vue&type=script&lang=ts&"
export * from "./NotificationCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218d17f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
